module.exports = __webpack_public_path__ + "static/2-Tri-10-c5f07779341bd0c24511555a06835cdc.png";